/**
 * PeriodChromeStyles — Plan 07-04 Task 1. Shared AESTHETIC-BRIEF Rule 7 tokens.
 *
 * The cream / espresso / warm-ochre palette and the Goudy Old Style / Cormorant
 * Garamond serif stack were duplicated inline across Plans 07-01 (placeholder
 * shells) and 07-03 (ReadTheTour body). This module is the canonical source
 * tokens consumed by:
 *
 *   - About.tsx (Plan 07-04) — page chrome + section styling
 *   - Credits.tsx (Plan 07-04) — page chrome + row styling
 *   - Sources.tsx (Plan 07-04) — page chrome + record/filter chip styling
 *   - ReadTheTour.tsx (Plan 07-03) — page chrome (optional refactor)
 *   - KeyboardHelp.tsx (Plan 07-03 / 07-06) — HUD overlay
 *
 * Why `Object.freeze`: the palette is a const contract, not a theme. No one
 * should assign into these objects at runtime — a freeze surfaces mistakes.
 *
 * The tokens are style values, not CSS classes. Consumers set them inline on
 * component style objects (matching the existing SourcesPanel + EraToggle
 * convention). Extracting to a global stylesheet is deferred to v1.1 styling
 * pass where it buys enough DRY to justify the architectural change.
 */

export const typography = Object.freeze({
  /** Serif stack for display + body text on the 3 content pages + HUD overlays. */
  serif:
    '"Goudy Old Style", "Cormorant Garamond", Georgia, "Times New Roman", serif',
  /** Sans-accent used sparingly for meta labels (e.g. source type chips). */
  sansAccent:
    '"Franklin Gothic Medium", "Franklin Gothic", "Arial Narrow", sans-serif',
});

export const periodChrome = Object.freeze({
  /** Page background — the AESTHETIC-BRIEF cream (matches period painted-paper feel). */
  cream: '#FDF6EE',
  /** Primary text color — warm near-black that reads as ink, not sterile #000. */
  espresso: '#3B2F2F',
  /** Warm-ochre accent — border strokes, active filter chips, link underlines. */
  ochre: '#D4A87E',
  /** Dimmer ochre for inactive chip borders + subtle dividers. */
  ochreDim: '#E8D9C4',
  /** Muted green — historically-appropriate accent reserved for v1.1 styling pass. */
  mutedGreen: '#6B7C4E',
  /** Warm-ochre emphasis for rationale / how-we-know text on Sources page. */
  warmOchre: '#B8602C',
});
